import React, { Component } from 'react';
import classNames from 'classnames';
import SearchIcon from '@mui/icons-material/Search';
import PropTypes from 'prop-types';
import { Form as FinalForm, Field } from 'react-final-form';
import { intlShape, injectIntl } from '../../util/reactIntl';

import { 
  FieldTextInput, 
  Form, 
  LocationAutocompleteInput, 
  OutsideClickHandler 
} from '../../components';

import { categoryOptions } from '../../filtersOptions';

import css from './TopbarSearchForm.module.css';

const identity = v => v;

class TopbarSearchFormComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      selectedCategory: null
    };

    this.onChange = this.onChange.bind(this);
    this.onOpenCategoryMenu = this.onOpenCategoryMenu.bind(this);
    this.onChangeCategory = this.onChangeCategory.bind(this);
    this.searchInput = null;
  }

  onChange(location) {
    if (location.selectedPlace) {
      // Note that we use `onSubmit` instead of the conventional
      // `handleSubmit` prop for submitting. We want to autosubmit
      // when a place is selected, and don't require any extra
      // validations for the form.
      this.props.onSubmit({ location });
      // blur search input to hide software keyboard
      if (this.searchInput) {
        this.searchInput.blur();
      }
    }
  }

  onOpenCategoryMenu(state) {
    this.setState({ isOpen: state })
  }

  onChangeCategory(category, form) {
    this.setState({ selectedCategory: category })
    form.change("pub_category", category.key)
  }

  render() {
    return (
      <FinalForm
        {...this.props}
        onSubmit={this.props.onSubmit}
        render={formRenderProps => {
          const {
            rootClassName,
            className,
            desktopInputRoot,
            intl,
            isMobile,
            handleSubmit,
            isProvider,
            values,
            form,
            providerType
          } = formRenderProps;

          const classes = classNames(rootClassName, className);
          const desktopInputRootClass = desktopInputRoot || css.desktopInputRoot;
          const isStartup = providerType === 'startup';


          // Allow form submit only when the place has changed
          // const preventFormSubmit = e => e.preventDefault();

          const { selectedCategory, isOpen } = this.state;

          const categoryMenu = (
            <OutsideClickHandler 
            onOutsideClick={() => this.onOpenCategoryMenu(false)}
            className={css.topbarCategories}
            >
              <div className={css.topbarCategoriesHolder} >
                <button
                  className={classNames(
                    css.topbarCategoriesBtn,
                    { [css.topbarCategoriesBtnPlaceholder]: !selectedCategory?.label },
                  )}
                  onClick={() => this.onOpenCategoryMenu(true)}
                  type="button"
                >
                  {selectedCategory?.label || "Select category"}
                </button>
                {isOpen && (
                  <ul className={css.topbarCategoriesMenuContent}>
                    {categoryOptions.map(item => {
                      return (
                        <li key={item.key} onClick={() => this.onOpenCategoryMenu(false)}>
                          <div className={css.topbarCategoriesMenuItem} onClick={() => this.onChangeCategory({ label: item.label, key: item.key }, form)}>
                            {item.label}
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                )}
              </div>
            </OutsideClickHandler>
          );

          return (
            <Form
              onSubmit={handleSubmit}
              className={classes}
              // onSubmit={preventFormSubmit}
              enforcePagePreloadFor="SearchPage"
            >
              {/* <Field
                name="location"
                format={identity}
                render={({ input, meta }) => {
                  const { onChange, ...restInput } = input;

                  // Merge the standard onChange function with custom behaviur. A better solution would
                  // be to use the FormSpy component from Final Form and pass this.onChange to the
                  // onChange prop but that breaks due to insufficient subscription handling.
                  // See: https://github.com/final-form/react-final-form/issues/159
                  const searchOnChange = value => {
                    onChange(value);
                    this.onChange(value);
                  };

                  const searchInput = { ...restInput, onChange: searchOnChange };
                  return (
                    <LocationAutocompleteInput
                      className={isMobile ? css.mobileInputRoot : desktopInputRootClass}
                      iconClassName={isMobile ? css.mobileIcon : css.desktopIcon}
                      inputClassName={isMobile ? css.mobileInput : css.desktopInput}
                      predictionsClassName={
                        isMobile ? css.mobilePredictions : css.desktopPredictions
                      }
                      predictionsAttributionClassName={
                        isMobile ? css.mobilePredictionsAttribution : null
                      }
                      placeholder={intl.formatMessage({ id: 'TopbarSearchForm.placeholder' })}
                      closeOnBlur={!isMobile}
                      inputRef={node => {
                        this.searchInput = node;
                      }}
                      input={searchInput}
                      meta={meta}
                    />
                  );
                }}
              /> */}

              <div className={css.searchInputWrapper}>
                <FieldTextInput
                  className={css.keywordsInput}
                  type="keywords"
                  name="pub_keywords"
                  id={'email'}
                  placeholder={isStartup ? 'Search startup' : 'Search service providers'}
                />
                {categoryMenu}
                <button type="submit" className={css.submitButton}>
                  <SearchIcon className={css.searchIcon} />
                </button>
              </div>
            </Form>
          );
        }}
      />
    );
  }
}

const { func, string, bool } = PropTypes;

TopbarSearchFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  desktopInputRoot: null,
  isMobile: false,
};

TopbarSearchFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  desktopInputRoot: string,
  onSubmit: func.isRequired,
  isMobile: bool,

  // from injectIntl
  intl: intlShape.isRequired,
};

const TopbarSearchForm = injectIntl(TopbarSearchFormComponent);

export default TopbarSearchForm;
